import React, { useMemo, useState } from "react";
import { MdUnfoldLess, MdUnfoldMore } from "react-icons/md";
import { buildPathTree } from "./contentUtils";

// Dynamic Content: the JSON of a language as a tree (generated from the
// document, no field names known in advance). A leaf inserts its full-path
// {{token}}; a key a token cannot express is shown but not insertable.
// Search matches keys and full paths ("revenue5", "example",
// "content.hero.title"); matching branches open automatically.
export default function ContentTree({ document, onInsert, t, usedTokens }) {
  const [query, setQuery] = useState("");
  const [openAll, setOpenAll] = useState(null);
  const [version, setVersion] = useState(0);
  const tree = useMemo(() => buildPathTree(document || {}, query), [document, query]);
  const used = useMemo(() => new Set(usedTokens || []), [usedTokens]);
  const searching = Boolean(query.trim());
  const setAll = (value) => { setOpenAll(value); setVersion((v) => v + 1); };

  const renderNodes = (nodes, depth) => nodes.map((node) => {
    if (node.isLeaf) {
      return <li key={node.path}>
        <button type="button" className={`eck-tree__leaf${node.token && used.has(node.token) ? " is-used" : ""}`} disabled={!node.token} title={node.token ? `{{${node.token}}}` : t.untokenizableKey} onClick={() => node.token && onInsert(node.token)}>
          <span className="eck-tree__key">{typeof node.key === "number" ? `[${node.key}]` : String(node.key)}</span>
          <code>{node.token ? `{{${node.token}}}` : node.path}</code>
        </button>
      </li>;
    }
    const open = searching || (openAll === null ? depth === 0 && nodes.length <= 1 : openAll);
    return <li key={`${node.path}-${version}`}>
      <details open={open}>
        <summary><span className="eck-tree__key">{typeof node.key === "number" ? `[${node.key}]` : String(node.key)}</span> <small>{node.children.length}</small></summary>
        <ul className="eck-tree__list">{renderNodes(node.children, depth + 1)}</ul>
      </details>
    </li>;
  });

  return <div className="eck-tree">
    <div className="eck-toolbar">
      <input className="eck-input eck-search" type="search" aria-label={t.searchContent} placeholder={t.searchContent} value={query} onChange={(e) => setQuery(e.target.value)} />
      <button type="button" className="eck-btn" onClick={() => setAll(true)}><MdUnfoldMore aria-hidden="true" /> {t.expandAll}</button>
      <button type="button" className="eck-btn" onClick={() => setAll(false)}><MdUnfoldLess aria-hidden="true" /> {t.collapseAll}</button>
    </div>
    {!tree.length ? <p className="eck-hint">{document && Object.keys(document).length ? t.noMatch : t.noContentJson}</p> : <ul className="eck-tree__list eck-tree__root">{renderNodes(tree, 0)}</ul>}
  </div>;
}
